<template>
  <div :class="['no-data', show ? 'fixed' : '']">
    <img src="../../public/img/icon6.png" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4.375rem 0;
  img {
    width: 12.5rem;
  }
}
.fixed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
